module.exports = __webpack_public_path__ + "img/map-tas.1c787460.png";